"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Promise = require("bluebird");
var Resizer = (function () {
    function Resizer(configParam) {
        if (configParam === void 0) { configParam = null; }
        this._config = {
            maxWidth: 300,
            thumbSize: 50,
            quality: 0.8
        };
        this.config = configParam;
    }
    Object.defineProperty(Resizer.prototype, "config", {
        get: function () {
            return this._config;
        },
        set: function (configParam) {
            this._config = __assign({}, this._config, configParam);
        },
        enumerable: true,
        configurable: true
    });
    Resizer.prototype.createCanvas = function (width, height) {
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    };
    Resizer.prototype.getImageType = function (img) {
        if (img && img.src && img.src.split) {
            var data = img.src.split(';')[0];
            if (data && data.length > 3 && data.split) {
                return data.split(':')[1];
            }
        }
    };
    Resizer.prototype.getThumbFromImage = function (img) {
        if (!this.config.thumbSize) {
            return Promise.reject(new Error("Error: getThumbFromImage " + JSON.stringify(this.config) + " does not define thumbSize"));
        }
        var imgType = this.getImageType(img);
        if (!imgType) {
            return Promise.reject(new Error("Error: img src " + img.src + " does not appear to be a valid image"));
        }
        var canvas = this.scaleAndCropThumb(img, this.config.thumbSize);
        var imageData = canvas.toDataURL(imgType, this.config.quality);
        return Promise.resolve(imageData);
    };
    Resizer.prototype.scaleAndCropThumb = function (img, thumbSize) {
        var posx = Math.max(0, img.width - img.height) >> 1, posy = Math.max(0, img.height - img.width) >> 1, cropSize = Math.min(img.width, img.height), thumbCanvas = this.createCanvas(thumbSize, thumbSize);
        thumbCanvas.getContext('2d').drawImage(img, posx, posy, cropSize, cropSize, 0, 0, thumbSize, thumbSize);
        return thumbCanvas;
    };
    Resizer.prototype.scaleImage = function (_img) {
        var _this = this;
        var img = _img;
        return new Promise(function (resolve, reject) {
            if (!img.width || !img.height) {
                img = new Image();
                img.src = _img.src;
                img.onload = resolve;
            }
            else {
                return resolve();
            }
        })
            .then(function () {
            if (!img.width || !img.height) {
                return Promise.reject(new Error("Error: img src " + img.src + " does not appear to be a valid image"));
            }
            var boxWidth = _this.config.maxWidth || 0, boxHeight = _this.config.maxHeight || 0;
            if (!boxWidth && !boxHeight) {
                return Promise.reject(new Error("Error: scaleImage " + JSON.stringify(_this.config) + " does not define maxWidth and/or maxHeight"));
            }
            var snapToWidth = false, canvas = _this.createCanvas(img.width, img.height);
            canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
            var imgType = _this.getImageType(img);
            if (!imgType) {
                return Promise.reject(new Error("Error: img src " + img.src + " does not appear to be a valid image"));
            }
            var scale = 1;
            if (boxWidth && boxHeight) {
                snapToWidth = (canvas.width >= canvas.height);
            }
            else {
                snapToWidth = !!_this.config.maxWidth;
            }
            if (snapToWidth) {
                while (canvas.width >= (2 * boxWidth)) {
                    canvas = _this.getHalfScaleCanvas(canvas);
                }
                scale = boxWidth / canvas.width;
            }
            else {
                while (canvas.height >= (2 * boxHeight)) {
                    canvas = _this.getHalfScaleCanvas(canvas);
                }
                scale = boxHeight / canvas.height;
            }
            if (scale < 1) {
                canvas = _this.scaleCanvasWithAlgorithm(canvas, scale);
            }
            var imageData = canvas.toDataURL("" + imgType, _this.config.quality);
            return Promise.resolve(imageData);
        });
    };
    Resizer.prototype.scaleCanvasWithAlgorithm = function (canvas, scale) {
        var scaledCanvas = this.createCanvas(canvas.width * scale, canvas.height * scale);
        var srcImgData = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);
        var destImgData = scaledCanvas.getContext('2d').createImageData(scaledCanvas.width, scaledCanvas.height);
        this.applyBilinearInterpolation(srcImgData, destImgData, scale);
        scaledCanvas.getContext('2d').putImageData(destImgData, 0, 0);
        return scaledCanvas;
    };
    Resizer.prototype.getHalfScaleCanvas = function (canvas) {
        var halfCanvas = this.createCanvas(canvas.width / 2, canvas.height / 2);
        halfCanvas.getContext('2d').drawImage(canvas, 0, 0, halfCanvas.width, halfCanvas.height);
        return halfCanvas;
    };
    Resizer.prototype.applyBilinearInterpolation = function (srcCanvasData, destCanvasData, scale) {
        function inner(f00, f10, f01, f11, x, y) {
            var un_x = 1.0 - x;
            var un_y = 1.0 - y;
            return (f00 * un_x * un_y + f10 * x * un_y + f01 * un_x * y + f11 * x * y);
        }
        var iyv, iy0, iy1, ixv, ix0, ix1;
        var idxD, idxS00, idxS10, idxS01, idxS11;
        var dx, dy;
        var r, g, b, a;
        for (var i = 0; i < destCanvasData.height; ++i) {
            iyv = i / scale;
            iy0 = Math.floor(iyv);
            iy1 = (Math.ceil(iyv) > (srcCanvasData.height - 1) ? (srcCanvasData.height - 1) : Math.ceil(iyv));
            for (var j = 0; j < destCanvasData.width; ++j) {
                ixv = j / scale;
                ix0 = Math.floor(ixv);
                ix1 = (Math.ceil(ixv) > (srcCanvasData.width - 1) ? (srcCanvasData.width - 1) : Math.ceil(ixv));
                idxD = (j + destCanvasData.width * i) * 4;
                idxS00 = (ix0 + srcCanvasData.width * iy0) * 4;
                idxS10 = (ix1 + srcCanvasData.width * iy0) * 4;
                idxS01 = (ix0 + srcCanvasData.width * iy1) * 4;
                idxS11 = (ix1 + srcCanvasData.width * iy1) * 4;
                dx = ixv - ix0;
                dy = iyv - iy0;
                r = inner(srcCanvasData.data[idxS00], srcCanvasData.data[idxS10], srcCanvasData.data[idxS01], srcCanvasData.data[idxS11], dx, dy);
                destCanvasData.data[idxD] = r;
                g = inner(srcCanvasData.data[idxS00 + 1], srcCanvasData.data[idxS10 + 1], srcCanvasData.data[idxS01 + 1], srcCanvasData.data[idxS11 + 1], dx, dy);
                destCanvasData.data[idxD + 1] = g;
                b = inner(srcCanvasData.data[idxS00 + 2], srcCanvasData.data[idxS10 + 2], srcCanvasData.data[idxS01 + 2], srcCanvasData.data[idxS11 + 2], dx, dy);
                destCanvasData.data[idxD + 2] = b;
                a = inner(srcCanvasData.data[idxS00 + 3], srcCanvasData.data[idxS10 + 3], srcCanvasData.data[idxS01 + 3], srcCanvasData.data[idxS11 + 3], dx, dy);
                destCanvasData.data[idxD + 3] = a;
            }
        }
    };
    return Resizer;
}());
exports.Resizer = Resizer;
